import React from 'react';
import img from '../../image/d5s7rjf-44e49087-3d72-423f-b240-af2326432d24.gif'
const Contact = () => {
    return (
        <div className='cus_img text-center py-10 my-10'>
            <h1>Contact page</h1>
           <img src={img} alt="" />
        </div>
    );
};

export default Contact;